import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ls0005',
    ecrans: ['00-2']
});
